/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    inProgress: true,
    saving: false,
    errors: null,
    openDeleteDialog: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'REQUEST_TEMPLATES':
            return {
                ...state,
                inProgress: false,
                dataList: action.payload
            };
        case 'REQUEST_TEMPLATE':
            return {
                ...state,
                inProgress: false,
                dataObject: action.payload,
                initialValues: action.payload
            };
        case 'SUBMIT_TEMPLATE':
            return {
                ...state,
                saving: false,
                dataObject: action.payload,
                initialValues: action.payload
            };
        case 'PREVIEW_TEMPLATE':
            return {
                ...state,
                saving: false,
                previewData: action.payload
            };
        case 'CONFIRM_DELETE_TEMPLATE':
            return {
                ...state,
                openDeleteDialog: action.payload
            };
        case 'DELETE_TEMPLATE':
            return {
                ...state,
                saving: false,
                openDeleteDialog: action.error ? true : false
            };
        case 'TEMPLATES_PAGE_UNLOADED':
        case 'TEMPLATE_PAGE_UNLOADED':
            return {...defaultState};
        case 'ASYNC_START':
            if (action.subtype === 'REQUEST_TEMPLATES'
                || action.subtype === 'REQUEST_TEMPLATE') {
                return { ...state, inProgress: true };
            } else if (action.subtype === 'SUBMIT_TEMPLATE'
                || action.subtype === 'DELETE_TEMPLATE'
                || action.subtype === 'PREVIEW_TEMPLATE'
                || action.subtype === 'SEND_TEMPLATE'
                ) {
                return { ...state, saving: true };
            }
            break;
    }

    return state;
};